import { usePostCouponApi, usePutCouponApi } from 'api/coupon'
import { Flex } from 'components/shared/flex'
import { CheckboxField, InputField } from 'components/shared/input'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useContext, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Form, useEffectSkipFirst, useForm } from 'utils/hooks'
import { ApiError } from 'utils/network/api_hooks'
import { Coupon, CouponForm } from 'entities/coupon'

const FormView = (form: Form<CouponForm>, apiError: ApiError) => {
    return (
        <>
            <Flex>
                <InputField form={form} attr="name" apiError={apiError} label="クーポン名称" />
            </Flex>
            <Flex>
                <InputField form={form} attr="discountPrice" apiError={apiError} label="割引額(円)" type="number" min={0} />
                <InputField
                    form={form}
                    attr="discountRate"
                    apiError={apiError}
                    label="割引率"
                    type="number"
                    min={0}
                    max={1}
                    placeholder="例) 0.05 (=5%割引)"
                    step={0.01}
                />
            </Flex>
            <div style={{ fontSize: 12, marginBottom: 20 }}>※ 組み合わせ可能</div>
            <CheckboxField form={form} attr="hasCode" apiError={apiError} checkboxLabel="クーポンコードを発行する" />
            <div style={{ fontSize: 12, marginBottom: 10 }}>※ クーポンコードを発行しない場合は検品時にマニュアル選択となります</div>
            <InputField form={form} attr="note" apiError={apiError} as="textarea" label="備考" />
        </>
    )
}

type NewCouponFormProps = {
    onComplete?: () => void
}

export const NewCouponForm = (props: NewCouponFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePostCouponApi()
    const form = useForm<CouponForm>({})
    const [show, setShow] = useState<boolean>(false)

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                setShow(false)
                props.onComplete()
            }
        }
    }, [api.loading])

    const handleClose = () => {
        setShow(false)
    }

    return (
        <>
            <Button
                variant="success"
                onClick={() => {
                    setShow(true)
                }}
            >
                新規登録
            </Button>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>クーポンの登録</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <>{FormView(form, api.apiError)}</>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        閉じる
                    </Button>
                    <Button variant="success" onClick={handleUpdate}>
                        登録
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
type EditCouponFormProps = {
    coupon: Coupon
    show: boolean
    onClose: () => void
    onComplete?: () => void
}

export const EditCouponForm = (props: EditCouponFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePutCouponApi()
    const form = useForm<CouponForm>(props.coupon)

    useEffectSkipFirst(() => {
        form.set(props.coupon)
    }, [props.coupon])

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                props.onComplete()
            }
        }
    }, [api.loading])

    return (
        <Modal show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>クーポンの編集</Modal.Title>
            </Modal.Header>
            <Modal.Body>{form.object.id && FormView(form, api.apiError)}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onClose}>
                    閉じる
                </Button>
                <Button variant="success" onClick={handleUpdate}>
                    更新
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
